import type { SearchResult } from '../../http/Fetcher';
import { buildQueryParams, requestBuilder } from '../../http/RequestBuilder';
import type {
    GuidanceSession,
    SearchGuidanceSessionRequest,
} from '../types/GuidanceSessions';

/**
 * A hook that accepts detailed params for a flexible/specific lookup of Guidance sessions.
 * Note: Results exclude sessions with 'status' of
 *     GuidanceSessionStatus.CANCELED
 *     GuidanceSessionStatus.NO_SHOWED
 */
const useSearchGuidanceSessions = requestBuilder.query<
    SearchResult<GuidanceSession>,
    SearchGuidanceSessionRequest
>({
    endpoint: ({ userId, ...query }) =>
        `/api/guidance/sessions/${userId}${buildQueryParams(query)}`,
    queryKey: ({ state, limit, offset, sortField, sortDirection }) => [
        'searchGuidanceSessions',
        { state, limit, offset, sortField, sortDirection },
    ],
});

export default useSearchGuidanceSessions;
